import { TemplateConfig } from '../types';

export const academicHexagramConfig: TemplateConfig = {
  id: 'academic-hexagram',
  name: '学业六芒星',
  description: '分析学业问题的来龙去脉和解决方法',
  cardCount: 7,
  
  fieldDefaults: {
    title: '学业六芒星',
    customerQuestion: '**在学业方面，想知道问题发生的来龙去脉前因后果，及周遭环境对这件事的助益或阻碍之处，并选择好的解决方法。**',
    cardPlaceholders: [
      '请输入第 2 列第 1 张牌',
      '请输入第 3 列第 2 张牌',
      '请输入第 1 列第 2 张牌',
      '请输入第 2 列第 3 张牌',
      '请输入第 1 列第 1 张牌',
      '请输入第 3 列第 1 张牌',
      '请输入第 2 列第 2 张牌'
    ],
    cardInfos: [
      '过去三个月的学业状况',
      '问题的根源',
      '外界环境的影响',
      '你现在最需要的',
      '未来半个月的发展',
      '未来三个月如果不改变的趋势',
      '建议和指导'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#13c2c2',
    backgroundColor: '#e6fffb',
    icon: '✨'
  }
};